import React from 'react'
import {usePageTitle} from '../hooks/use-page-title'
import {Layout} from "../app/layout";
import {Button, Container, createStyles, Divider, Grid, Group, Paper, Text} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import {useListenerQuery} from "../store/slice/customApiSlice";

export type AccountData = {
  userData: {
    name: string
    surname: string
    patronymic: string
  },
  lawyerPersonalAccountData: {
    accountAddress: string
    advocacyFormId?: string
    advocacyForm: {
      id: number
      title: string
      type: {
        code: string
        editable: boolean
        id: number
        title: string
      }
    }
    denomination: string
    email: string
    lawyerOfficeEstablishmentNotificationDate: string
    lawyersInformation: string
    phoneNumber: string
    specialization: string
    stateRegistrationInformation: string
  }
}

// const schema = Yup.object().shape({
//   address: Yup.string().required('Введите адрес'),
// });

type ContactIconVariant = 'white' | 'gradient';

interface ContactIconStyles {
  variant: ContactIconVariant;
}

const useStyles = createStyles((theme, {variant}: ContactIconStyles) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    color: theme.white,
  },

  title: {
    color: variant === 'gradient' ? theme.colors.gray[6] : theme.colors[theme.primaryColor][0],
    width: "100%",
  },

  description: {
    color: variant === 'gradient' ? theme.black : theme.white,
  },
}));

interface ContactIconProps extends Omit<React.ComponentPropsWithoutRef<'div'>, 'title'> {
  title: React.ReactNode;
  description: React.ReactNode;
  variant?: ContactIconVariant;
}

function ContactIcon({
                       title,
                       description,
                       variant = 'gradient',
                       className,
                       ...others
                     }: ContactIconProps) {
  const {classes, cx} = useStyles({variant});
  return (
    <div className={cx(classes.wrapper, className)} {...others}>
      <div>
        <Text size="xs" className={classes.title}>
          {title}
        </Text>
        <Text className={classes.description}>{description}</Text>
      </div>
    </div>
  );
}

interface ContactIconsListProps {
  data?: ContactIconProps[];
  variant?: ContactIconVariant;
}


export const Profile = () => {
  usePageTitle('Профиль')
  // const { profile } = useAppSelector((state: any) => ({
  //   profile: state.profile,
  // }));
  const history = useNavigate()

  const renderRedirect = () => {
    return history('/profile-edit')
  }

  const {data: accountData} = useListenerQuery<{
    data: AccountData
  }>({
    path: `/lawyers/personal-account`,
  })

  const MOCKDATA = [
    {title: 'Имя', description: accountData?.userData.name || '-'},
    {title: 'Фамилия', description: accountData?.userData.surname || '-'},
    {title: 'Отчество', description: accountData?.userData.patronymic || '-'},
    {title: 'Специализация', description: accountData?.lawyerPersonalAccountData?.specialization || '-'},
    {
      title: 'Форма адвокатской деятельности',
      description: accountData?.lawyerPersonalAccountData?.advocacyForm.title || '-'
    },
    {
      title: 'Наименование адвокатского кабинета',
      description: accountData?.lawyerPersonalAccountData?.denomination || '-'
    },
    {title: 'Юридический адрес', description: accountData?.lawyerPersonalAccountData?.accountAddress || '-'},
    {title: 'Номер телефона', description: accountData?.lawyerPersonalAccountData?.phoneNumber || '-'},
    {title: 'Адрес электронной почты', description: accountData?.lawyerPersonalAccountData?.email || '-'},
    {
      title: 'Дата уведомления об учреждении адвокатского кабинета',
      description: accountData?.lawyerPersonalAccountData?.lawyerOfficeEstablishmentNotificationDate?.toString() || '-'
    },
    {
      title: 'Сведения об адвокатах, осуществляющих деятельность в составе организации',
      description: accountData?.lawyerPersonalAccountData?.lawyersInformation || '-'
    },
    {
      title: 'Сведения о государственной регистрации адвокатской организации',
      description: accountData?.lawyerPersonalAccountData?.stateRegistrationInformation || '-'
    },

  ];

  function ContactIconsList({data = MOCKDATA, variant}: ContactIconsListProps) {
    const items1 = data.slice(0, data.length / 2).map((item, index) => <ContactIcon key={index}
                                                                                    variant={variant} {...item} />);
    const items2 = data.slice(data.length / 2, data.length).map((item, index) => <ContactIcon key={index}
                                                                                              variant={variant} {...item} />);
    return (
      // <SimpleGrid cols={1} sx={{ background: "grey" }}>
      <Grid>
        <Grid.Col xs={12} md={6} sx={{display: "flex", gap: "10px", flexDirection: "column"}}>
          {items1}
        </Grid.Col>
        <Grid.Col xs={12} md={6} sx={{display: "flex", gap: "10px", flexDirection: "column"}}>
          {items2}
        </Grid.Col>
      </Grid>
      // </SimpleGrid>
    );
  }

  return (
    <Layout>
      <Container size={720} sx={{
        marginTop: '5rem'
      }}>

        <Paper radius="md" p="md" withBorder>

          <Divider label="Информация личного кабинета адвоката" labelPosition="center" my="xl"/>

          {/* <SimpleGrid cols={2} breakpoints={[{ minWidth: 755, cols: 2 }]} sx={{ background: "yellow" }}> */}
          {/* <Box
              sx={(theme) => ({
                padding: theme.spacing.xl,
                borderRadius: theme.radius.md,
                backgroundColor: theme.white,
              })}
            > */}
          <ContactIconsList/>
          {/* </Box> */}
          {/* </SimpleGrid> */}
          <Group position="center" mt="xl">
            <Button onClick={renderRedirect} variant='filled' color={'gray'}>Редактировать</Button>
          </Group>
        </Paper>
      </Container>
    </Layout>
  )
}
